import type { CSSProperties } from "react";
import { Minus, Plus } from "lucide-react";
import { C, FONT, clamp } from "../theme";

const btn: CSSProperties = {
  width: 26,
  height: 26,
  borderRadius: 8,
  border: `1px solid ${C.hairline}`,
  background: C.sand,
  color: C.textMid,
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
};

/** "− {value} min +" duration stepper. Clamps to [1, 60]; stops click propagation so it works inside a clickable card. */
export function Stepper({ value, onChange }: { value: number; onChange: (v: number) => void }) {
  return (
    <div
      style={{ display: "inline-flex", alignItems: "center", gap: 7 }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        aria-label="Less minutes"
        style={btn}
        onClick={() => onChange(clamp(value - 1, 1, 60))}
      >
        <Minus size={13} />
      </button>
      <span
        className="mono tnum"
        style={{ width: 54, textAlign: "center", fontFamily: FONT.mono, fontSize: 13, color: C.ink }}
      >
        {value} min
      </span>
      <button
        type="button"
        aria-label="More minutes"
        style={btn}
        onClick={() => onChange(clamp(value + 1, 1, 60))}
      >
        <Plus size={13} />
      </button>
    </div>
  );
}
